<template>
  <detra-modal :show="show_modal" @hide="hide()">
    <div class="p-24 pb-0">
      <div class="heading-medium">
        <span v-if="!edit && client">Add new project for "{{ client.name }}"</span>
        <span v-if="edit && project">Edit {{ project.name }}</span>
      </div>
    </div>
    <project-details-edit ref="project_details" v-model="project" :client="client" :lock_client="lock_client" :validation="validation"></project-details-edit>
    <div class="divider" v-show="!edit"></div>
    <task-details-edit v-show="!edit" :project="project" v-model="task_data"></task-details-edit>
    <div class="divider"></div>
    <div class="text-center p-24">
      <div class="btn btn-jet w-240" @click="save()">
        <span v-if="!edit">Add project</span>
        <span v-if="edit">Update</span>
      </div>
    </div>
  </detra-modal>
</template>
<script>
import ProjectDetailsEdit from './project-details-edit'
import TaskDetailsEdit from './task-details-edit'

export default {
  components: {
    ProjectDetailsEdit,
    TaskDetailsEdit,
  },
  created() {
    this.$root.$on('ProjectModal::add-project', ({client}) => {
      this.client = client
      this.lock_client = true
      this.$root.$emit('TaskDetailsEdit::reset')
      this.$root.$emit('ProjectDetailsEdit::reset', {client})
      this.show()
    })
    this.$root.$on('ProjectModal::edit-project', ({project_id}) => {
      this.axios.get('/n/projects/' + project_id + '?with[]=client.manager&with[]=service').then(response => {
        this.$root.$emit('TaskDetailsEdit::reset')
        this.$root.$emit('ProjectDetailsEdit::setProject', {project: response.data.data})
        this.project_id = project_id
        this.edit = true
        this.lock_client = false
        this.show()
      })
    })
  },
  data() {
    return {
      validation: {},
      show_modal: false,
      project: null,
      client: null,
      task_data: null,
      edit: false,
      project_id: null,
      lock_client: false,
    }
  },
  methods: {
    show() {
      this.show_modal = true
      this.$nextTick(() => {
        // this.$refs.project_details.$refs.project_name_input.focus()
      })
    },
    hide() {
      this.show_modal = false
      this.project_id = null
      this.edit = false
    },
    save() {
      this.validation = {}

      let data = {
        project: {
          name: this.project.name,
          client_id: this.project.client.id,
          deadline: this.project.deadline,
          fixed_price: this.project.fixed_price,
          duration: this.project.duration,
          description: this.project.description,
          service_id: this.project.service ? this.project.service.id : null,
        },
        tasks: this.task_data.tasks,
        template_name: this.task_data.template_name,
      }

      if (!data.project.service_id) {
        this.validation.service_id = true
      }
      if (!data.project.duration) {
        this.validation.duration = true
      }

      console.log(this.validation, this.validation.length)

      if (this.validation.duration || this.validation.service_id) return

      if (!this.edit) {
        this.axios.post('/n/projects', data).then(response => {
          this.$root.$emit('Projects::created', response.data.data)
          this.hide()
        }).catch(e => {
          if (e.response && e.response.status && e.response.status == 422) {
            let msg = "[" + e.response.status + "]" + " " + e.response.statusText
            msg = e.response.data && e.response.data.message ? e.response.data.message : msg
            this.$awn.alert(msg);
          }
        })
      } else {
        this.axios.put('/n/projects/' + this.project_id, data).then(response => {
          this.$root.$emit('Projects::updated', {project: response.data.data})
          this.hide()
        }).catch(e => {

          if (e.response && e.response.status && e.response.status == 422) {
            let msg = "[" + e.response.status + "]" + " " + e.response.statusText
            msg = e.response.data && e.response.data.message ? e.response.data.message : msg
            this.$awn.alert(msg);
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/agenda-v2/task-pool/project-modal/project-modal.vue